module.exports = __webpack_public_path__ + "static/media/shadenet_blog_img.2280598e.png";